import React, {
    useEffect,
    useState
} from 'react'

import {
    useDispatch,
    useSelector
} from 'react-redux'
import {Link} from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Table from "react-bootstrap/Table"
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import Card from "react-bootstrap/Card"
import { getAllCustomForms, selectAllCustomForms, createForm, deleteForm, deleteAllForms, updateFormTitle, getAllAssignedForms } from "../../state/customFormsSlice"

import {
    getAllClients,
    selectTrainerParam
} from '../users/usersSlice.js'


function CustomAppSuccess() {

    const url = new URL(window.location.href)
    const urlParams = new URLSearchParams(url.search);

    let customType = urlParams.get('customType')
    const typeDisplayText = {
        'ios':'iOS',
        'ios_lite':'Lite iOS',
        'android':'Android',
        'web':'Web'
    }[customType]
    console.log(customType)
    return (
        <div class="mx-5 mt-5 mx-auto" style={{maxWidth:"800px"}}>
            <h1 style={{ textTransform: "capitalize" }}> {typeDisplayText} Customization Payment Successful! </h1>
            <hr />
            <div class="px-5 py-5 bg-white" >
                {customType !== "web" &&
                    <div style={{ fontSize: "1.2rem", fontWeight: "bolder" }}>
                        Please send an email to <a href="mailto:nate@fitsw.com"> nate@fitsw.com </a>
                        with the following information so that we can start on your customization:
                    </div>
                }
                {customType == "ios" &&
                    <div >
                        <ul className="mt-3" style={{ listStyleType: "none" }}>
                            <li>
                                1) A Logo for your app icon and a Logo for your splash screen.

                                <div className="my-3">
                                    <b> Note:  </b>
                                    App Icon Logos are usually simpler and round / square (look at something like the facebook App icon on your phone).
                                    Logos for splash screen are usually your full logo and dont have to be round / square.
                                    Push notification logos should have a transparent background and be square. Please specify which logo is for which in your email.
                                </div>

                            </li>
                            <li>2) Preferred App Icon Background Color</li>
                            <li>3) Preferred App Title (30 Characters or less)</li>
                            <li>4) Preferred App Sub Title (30 Characters or less)</li>
                            <li>5) Preferred App Description (4000 character limit)</li>
                        </ul>
                        <div style={{ fontSize: "1.1rem"}} className="py-2">
                            Please also complete the following guides so that we can get started on your iOS App:
                        </div>
                        <ul>
                            <li> <a href="https://www.fitsw.com/help/for-trainers/other-trainers/how-to-setup-apple-developer-id-for-the-custom-app/"> How To Setup An Apple Developer ID</a></li>
                            <li> <a href="https://www.fitsw.com/help/for-trainers/other-trainers/how-to-create-a-bundle-id-for-custom-app-ios/" > How To Create A Bundle ID </a></li>
                        </ul>
                        <div className="my-3 p-3" style={{ border: "2px solid grey", borderRadius: "1.5rem" }}>
                            If you need an app revision or change in the future after your custom app is released,
                            please note that we do charge $50 for logo changes, color changes or any other changes after the initial release of the app.
                            This is due to the fact that rereleasing the app with changes takes considerable time.
                        </div>
                    </div>
                }
                {customType == "android" &&
                    <div>
                        <ul className="mt-3" style={{ listStyleType: "none" }}>
                            <li >
                                1) Logos:
                                <ol style={{ listStyleType: "lower-alpha" }}>
                                    <li>
                                        Logo for your app icon
                                    </li>
                                    <li>
                                        Logo for your splash screen
                                    </li>
                                    <li>
                                        Logo for push notifications.
                                    </li>
                                </ol>
                                <div className="my-3">
                                    <b> Note:  </b>
                                    App Icon Logos are usually simpler and round / square (look at something like the facebook App icon on your phone).
                                    Logos for splash screen are usually your full logo and dont have to be round / square.
                                    Push notification Logos should have a transparent background and be square. Please specify which Logo is for which in your email.
                                </div>
                            </li>
                            <li>2) Preferred App Icon Background Color</li>
                            <li>3) Preferred App Title (50 Characters or less)</li>
                            <li>4) Preferred App Short Description (80 Characters or less)</li>
                            <li>5) Preferred App Full Description (4000 character limit)</li>
                            <li>6) Preferred Color for buttons (please send hex color code)</li>
                        </ul>
                        <div className="my-3 p-3" style={{ border: "2px solid grey", borderRadius: "1.5rem" }}>
                            If you need an app revision or change in the future after your custom app is released,
                            please note that we do charge $50 for logo changes, color changes or any other changes after the initial release of the app.
                            This is due to the fact that rereleasing the app with changes takes considerable time.
                        </div>
                    </div>
                }

                {customType == "email" &&
                    <div>
                        <ul className="mt-3" style={{ listStyleType: "none" }}>
                            <li>1) The header image you want for your emails. It should be a png that is 558 px width and 70 px height.</li>
                        </ul>
                    </div>
                }

                {customType == "web" &&
                    <div style={{ fontSize: "1.2rem"}} className="mx-3 mb-5 mt-3">
                        <div> 
                            <Link to="/customization-dashboard/"> Customize Your App </Link>
                        </div>
                    </div>
                }

                <Button> <a href="/upgradeCustom/" className="text-white"> Return To Custom Upgrade Screen</a> </Button>
            </div>

        </div>)
}

export default CustomAppSuccess